// extracted by mini-css-extract-plugin
export var heading_title = "pannelHero-module--heading_title--e4209";
export var hero_container = "pannelHero-module--hero_container--d384a";
export var sub_heading = "pannelHero-module--sub_heading--93b1d";
export var title_heading = "pannelHero-module--title_heading--1f507";